import { render, staticRenderFns } from "./EinstenFormPerson.vue?vue&type=template&id=7796e00d"
import script from "./EinstenFormPerson.vue?vue&type=script&lang=js"
export * from "./EinstenFormPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports